/*
 * Passes the Amazon Attribution tag from the landing URL to the Amazon link.
 *
 * The Meta ad URL carries the whole Attribution tag, e.g.
 *   ?aa_campaignid=…&aa_adgroupid=…&aa_creativeid=…&maas=maas_adg_api_…&platform=FACEBOOK&ref_=aa_maas&tag=maas
 * These params are copied onto the Link from the Advertorial entry. The Link can be
 *   - a plain Amazon link:   https://www.amazon.com/dp/<ASIN>
 *   - a redirect / deep link service that forwards query params to Amazon (e.g. LinkTwin https://linktw.in/…)
 * Result: <link>?aa_campaignid=…&aa_adgroupid=…&aa_creativeid=…&maas=…&platform=FACEBOOK&ref_=aa_maas&tag=maas
 *
 * Fallback: if the page has only utm_campaign / utm_term / utm_content, they become
 * aa_campaignid / aa_adgroupid / aa_creativeid.
 *
 * Safe by design: the link is changed only when the visit carries the Attribution tag (maas)
 * or the link already has one; otherwise it stays exactly as entered. Extra query params
 * don't break the link, and any error leaves the original link working.
 */
(() => {
  // Attribution params copied as-is from the landing URL
  const PASS = ['aa_campaignid', 'aa_adgroupid', 'aa_creativeid', 'maas', 'platform', 'ref_', 'tag'];
  // UTM fallback (only used when the aa_* param itself is missing)
  const UTM = { utm_campaign: 'aa_campaignid', utm_term: 'aa_adgroupid', utm_content: 'aa_creativeid' };
  const STORAGE_KEY = 'advertorial_amazon_attribution';

  // Skip empty values and macros Meta didn't replace, e.g. "{{campaign.id}}"
  const usable = (value) => Boolean(value) && !value.includes('{{');

  function readParams() {
    const out = {};
    try {
      const params = new URLSearchParams(window.location.search);
      PASS.forEach((key) => {
        const value = (params.get(key) || '').trim();
        if (usable(value)) out[key] = value;
      });
      Object.keys(UTM).forEach((utm) => {
        const value = (params.get(utm) || '').trim();
        if (!out[UTM[utm]] && usable(value)) out[UTM[utm]] = value;
      });
      if (Object.keys(out).length) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(out));
        return out;
      }
      // Same session, URL without params (e.g. user navigated back): reuse saved ones.
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (error) {
      return out;
    }
  }

  function withParams(href, params) {
    try {
      const url = new URL(href, window.location.href);
      if (!/^https?:$/.test(url.protocol)) return href;
      // Without the Attribution tag (from the visit or already in the link) Amazon ignores aa_* IDs.
      if (!params.maas && !url.searchParams.has('maas')) return href;
      Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
      return url.toString();
    } catch (error) {
      return href;
    }
  }

  function init() {
    const params = readParams();
    if (!Object.keys(params).length) return;

    document.querySelectorAll('a[data-advertorial-amazon-link]').forEach((link) => {
      const original = link.getAttribute('href');
      if (!original) return;
      const updated = withParams(original, params);
      if (updated !== original) link.setAttribute('href', updated);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
